@for (toast of toastService.toasts; track toast) {
    <ngb-toast
        [class]="toast.toastType"
        [autohide]="toast.autoHide"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
    >
        <div class="toast-content">
            <span>{{toast.message}}</span>
        
            @if(toast.showCloseButton || toast.toastType == TOAST_TYPE.ERROR) {
                <button class="close-btn" (click)="toastService.remove(toast)">x</button>
            }
        </div>
        
    </ngb-toast>
}